import { render } from "./choixtable.vue?vue&type=template&id=3220245c&scoped=true"
import script from "./choixtable.vue?vue&type=script&lang=js"
export * from "./choixtable.vue?vue&type=script&lang=js"

import "./choixtable.vue?vue&type=style&index=0&id=3220245c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3220245c"]])

export default __exports__